import React, { useState,useEffect, useRef } from "react";
import { Formik, Form, Field,FieldArray, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from "axios";
import AdminPage from "./AdminPage";

import { SERVERURL } from "../../ServerUrl";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import HomeTopBar from "../HomeTopBar/HomeTopBar";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Swal from "sweetalert2";
const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml', 'image/JPEG', 'image/JPG', 'image/PNG'];
const schema = Yup.object().shape({
  title: Yup.string().max(30, 'Title cannot exceed 30 characters').required('Title is required'),
  description: Yup.string().required('Description is required'),
  shortDescription: Yup.string().max(50, 'Short description cannot exceed 50 characters').required('Short description is required'),
  startDate: Yup.date().required('Start date is required').min(new Date(), 'Start date cannot be in the past'),
  endDate: Yup.date().required('End date is required').min(Yup.ref('startDate'), 'End date must be later than start date'),
  type: Yup.string().oneOf(['Gaming', 'AI', 'Infrastructure', 'DEFI', 'Metaverse', 'NFTs'], 'Invalid event type').required('Type is required'),
  location: Yup.string().required('Location is required'),
  countryCode: Yup.string().matches(/^[A-Z]{2,3}$/, 'Invalid country code').required('Country code is required'),
  websiteLink: Yup.string().url('Please enter a valid URL').nullable(),
  instagramLink: Yup.string().url('Please enter a valid URL').nullable(),
  twitterLink: Yup.string().url('Please enter a valid URL').nullable(),
  linkedinLink: Yup.string().url('Please enter a valid URL').nullable(),
  startTime: Yup.string().matches(/^([01]\d|2[0-3]):([0-5]\d)$/, 'Invalid time format').required('Start time is required'),
  endTime: Yup.string().matches(/^([01]\d|2[0-3]):([0-5]\d)$/, 'Invalid time format').required('End time is required'),
  coverImage: Yup.mixed().required('Cover image is required').test('fileType', 'Only JPG, JPEG, PNG, and SVG images are allowed', (file) => file && allowedFileTypes.includes(file.type)),
  hashtags: Yup.array().of(Yup.string().required('Hashtag is required')).nullable(),
});


const COPY = {
  title: "Add Event",
  subtitle:
    "Provide the details of your Event. Ensure all fields are filled out accurately to share your Event with the world.",
};

const CreateEvent = () => {
  const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);
  return (
    <AdminPage title={COPY.title} subtitle={COPY.subtitle}>
      <div className="admin-card" style={{ maxWidth: "820px" }}>
            <Formik
          initialValues={{
            title: '',
            description: '',
            shortDescription: '',
            startDate: '',
            endDate: '',
            type: '',
            location: '',
            countryCode: '',
            websiteLink: '',
            instagramLink: '',
            twitterLink: '',
            linkedinLink: '',
            startTime: '',
            endTime: '',
            coverImage: null,
            hashtags: [],
          }}
          validationSchema={schema}
          onSubmit={async (values, { setSubmitting }) => {
            const formData = new FormData();
          
            // Append simple fields
            formData.append('title', values.title);
            formData.append('description', values.description);
            formData.append('shortDescription', values.shortDescription);
            formData.append('startDate', values.startDate);
            formData.append('endDate', values.endDate);
            formData.append('type', values.type);
            formData.append('location', values.location);
            formData.append('countryCode', values.countryCode);
            formData.append('websiteLink', values.websiteLink);
            formData.append('instagramLink', values.instagramLink);
            formData.append('twitterLink', values.twitterLink);
            formData.append('linkedinLink', values.linkedinLink);
            formData.append('startTime', values.startTime);
            formData.append('endTime', values.endTime);
          
            // Handle coverImage upload
            if (values.coverImage) {
              formData.append('coverImage', values.coverImage);
            }
          
            // Handle hashtags array
              const hashtagsJSON = JSON.stringify(values.hashtags);
              formData.append('hashtags', hashtagsJSON);
            
          
            // Print form data for debugging
            formData.forEach((value, key) => {
              console.log(`${key}: ${value}`);
            });
          
            // API call to /AddEvent
            const token = localStorage.getItem('token');
          
            try {
              if (token) {
                const headers = {
                  'Authorization': `Bearer ${token}`,
                };
          
                const response = await axios.post(
                  `${SERVERURL}/api/v1/AddEvent`,
                  formData,
                  {
                    headers: headers,
                    onUploadProgress: (progressEvent) => {
                      const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
          
                      setProgress(progress);
                      setUploading(true);
                    },
                  }
                );
          
                // Handle success response
                if (response.status === 200) {
                  Swal.fire({
                    icon: "success",
                    title: "Event Uploaded Successfully",
                    text: response.data.message,
                  });
                } else {
                  Swal.fire({
                    icon: "error",
                    title: "An error occurred",
                    text: response.data.message,
                  });
                }
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Sign in to upload Event",
                  text: "Guest User can't upload Event.",
                });
              }
            } catch (error) {
              Swal.fire({
                icon: "error",
                title: "An error occurred",
                text: "Event Not Uploaded.",
              });
            } finally {
              setUploading(false); // Reset uploading state
              setSubmitting(false); // Reset submitting state to false
            }
          }}
          
          
          
        >
          {({ values,isSubmitting, setFieldValue }) => (
            <Form>
                {/* Title Field */}
                <div className='mb-3'>
                    <label className="admin-label">Title <span className="admin-error">*</span></label>
                    <Field type="text" name="title" className="admin-input" />
                    <ErrorMessage name="title" component="div" className="admin-error" />
                </div>


{/* Short Description Field */}
<div className='mb-3'>
                    <label className="admin-label">Short Description <span className="admin-error">*</span></label>
                    <Field type="text" name="shortDescription" className="admin-input" />
                    <ErrorMessage name="shortDescription" component="div" className="admin-error" />
                </div>

                {/* Description Field */}
                <div className='mb-3'>
                    <label className="admin-label">Description <span className="admin-error">*</span></label>
                    <Field name="description">
                        {({ field }) => (
                            <ReactQuill
                                value={field.value}
                                onChange={field.onChange(field.name)}
                                className="admin-input"
                            />
                        )}
                    </Field>
                    <ErrorMessage name="description" component="div" className="admin-error" />
                </div>
              {/* Container for Start and End Dates */}
              <div className="w-full flex flex-col md:flex-row md:space-x-4">
                {/* Start Date */}
                <div className="flex-1 mb-4 md:mb-0">
                  <label className="admin-label">Start Date <span className="admin-error">*</span></label>
                  <Field 
                    type="date" 
                    name="startDate" 
                    className="admin-input" 
                  />
                  <ErrorMessage name="startDate" component="div" className="admin-error" />
                </div>

                {/* End Date */}
                <div className="flex-1 mb-4 md:mb-0">
                  <label className="admin-label">End Date <span className="admin-error">*</span></label>
                  <Field 
                    type="date" 
                    name="endDate" 
                    className="admin-input" 
                  />
                  <ErrorMessage name="endDate" component="div" className="admin-error" />
                </div>
              </div>

              {/* Type Field */}
              <div className='my-3'>
                <label className="admin-label" htmlFor="sortBy">Type <span className="admin-error">*</span></label>
                <Field as="select" name="type" className="admin-input">
                  <option value="">Select an Type</option>
                  <option value="Gaming">Gaming</option>
                  <option value="AI">AI</option>
                  <option value="DEFI">DEFI</option>
                  <option value="Metaverse">Metaverse</option>
                  <option value="NFTs">NFTs</option>
                  <option value="Infrastructure">Infrastructure</option>
                </Field>
                <ErrorMessage name="type" component="div" className="admin-error" />
              </div>

              {/* Location */}
              <div className='mb-3'>
                <label className="admin-label">Location <span className="admin-error">*</span></label>
                <Field type="text" name="location" className="admin-input" />
                <ErrorMessage name="location" component="div" className="admin-error" />
              </div>

              {/* Country Code */}
              <div className='mb-3'>
                <label className="admin-label">Country Code <span className="admin-error">*</span></label>
                <Field type="text" name="countryCode" className="admin-input" />
                <ErrorMessage name="countryCode" component="div" className="admin-error" />
              </div>

              {/* {links} */}
              <div className="my-4 flex justify-between">
                    {/* websiteLink */}
                    <div className='w-1/2 pr-2'>
                        <label className="admin-label">Website Link </label>
                        <Field type="url" name="websiteLink" className="admin-input" />
                        <ErrorMessage name="websiteLink" component="div" className="admin-error" />
                    </div>

                    {/* instagramLink*/}
                    <div className='w-1/2 pl-2'>
                        <label className="admin-label">Instagram Link </label>
                        <Field type="url" name="instagramLink" className="admin-input" />
                        <ErrorMessage name="instagramLink" component="div" className="admin-error" />
                    </div>
                </div>

                {/* {links} */}
              <div className="my-4 flex justify-between">
                    {/* twitterLink */}
                    <div className='w-1/2 pr-2'>
                        <label className="admin-label">Twitter Link </label>
                        <Field type="url" name="twitterLink" className="admin-input" />
                        <ErrorMessage name="twitterLink" component="div" className="admin-error" />
                    </div>

                    {/* linkedinLink*/}
                    <div className='w-1/2 pl-2'>
                        <label className="admin-label">Linkedin Link </label>
                        <Field type="url" name="linkedinLink" className="admin-input" />
                        <ErrorMessage name="linkedinLink" component="div" className="admin-error" />
                    </div>
                </div>

              {/* Container for Start and End Times */}
              <div className="w-full flex space-x-4">
                {/* Start Time */}
                <div className="flex-1">
                  <label className="admin-label">Start Time <span className="admin-error">*</span></label>
                  <Field 
                    type="time" 
                    name="startTime" 
                    className="admin-input" 
                  />
                  <ErrorMessage name="startTime" component="div" className="admin-error" />
                </div>
                {/* End Time */}
                <div className="flex-1 mb-3">
                  <label className="admin-label">End Time <span className="admin-error">*</span></label>
                  <Field 
                    type="time" 
                    name="endTime" 
                    className="admin-input" 
                  />
                  <ErrorMessage name="endTime" component="div" className="admin-error" />
                </div>
              </div>

               {/* Hashtags */}
               
<FieldArray name="hashtags">
                {({ remove, push }) => (
                  <div className='my-3'>
                    {values.hashtags && values.hashtags.length > 0 && values.hashtags.map((hashtag, index) => (
                      <div key={index} className="admin-subcard">
                        <div className="admin-field">
                          <label className="admin-label">Hashtag <span className="admin-error">*</span></label>
                          <Field
                            name={`hashtags.${index}`}
                            type="text"
                            className="admin-input"
                          />
                          <ErrorMessage name={`hashtags.${index}`} component="div" className="admin-error" />
                        </div>

                        <button type="button" onClick={() => remove(index)}
                          className="admin-action admin-action-delete">
                          Remove
                        </button>
                      </div>
                    ))}

                    <button
                      type="button"
                      onClick={() => push('')}
                      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mb-4"
                    >
                      Add Hashtag
                    </button>
                  </div>
                )}
              </FieldArray>
              {/* Cover Image */}
              <div className='mb-3'>
                <label className="admin-label">Cover Image <span className="admin-error">*</span></label>
                <input
                    type="file"
                    name="coverImage"
                    onChange={(event) => {
                        setFieldValue("coverImage", event.currentTarget.files[0]);
                    }}
                    className="admin-input"
                />
                <ErrorMessage name="coverImage" component="div" className="admin-error" />
              </div>

                {/* Submit Button */}
              <div className="flex items-center mt-3">
                <button
                    type="submit"
                    disabled={isSubmitting}
                    className="admin-btn"
                >
                    Submit
                </button>
              </div>
            </Form>
        )}
        </Formik>
        {uploading && (
          <div className="modddd">
                    <div className="coontent">                  
                      <p>Uploading: {progress}%</p>
                    <div className="w-full bg-gray-200 rounded">
                        <div className="bg-blue-500 text-xs leading-none py-1 text-center text-white rounded" style={{ width: `${progress}%` }}>
                            
                        </div>
                    </div>
                </div>
                </div>
            )}
      </div>
    </AdminPage>
  )
}

export default CreateEvent